import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CdwSlideToggleComponent } from './cdw-slide-toggle/cdw-slide-toggle.component';

@NgModule({
  imports: [CommonModule],
  declarations: [CdwSlideToggleComponent],
  exports: [CdwSlideToggleComponent],
})
export class CdwSlideToggleModule {}
